import React from 'react'
import { useApp } from '../../../context/AppProvider'
import { constructUrl, isEmpty } from '../../../services/common'
import { icon } from '../../../services/icon'
import { Attributes, Link } from '../../fiche'
import Parser from '../parser/Parser'

const TitleParser = ({ block, attributes, type }) => {
    const { setSelectedCase } = useApp()

    const onClickRetrievedId = () => {
        setSelectedCase((prev) => {
            const index = prev.findIndex((id) => id === attributes)
            if (index !== -1) return prev.slice(0, index)
            return prev
        })
    }

    const renderBlockContent = () => {
        switch (type) {
            case 'research-guide':
                return
            case 'link-internal':
                return (
                    <Link isIcon={false} url={constructUrl(attributes?.ID, attributes.audience)}>
                        <span className="baseocom-block-title-link-internal">
                            {icon('arrow-right')}
                        </span>
                        {block?.content}
                    </Link>
                )
            case 'checked':
                return (
                    <div className="baseocom-block-title-checked">
                        <div>
                            {icon('checked')}
                            <h3>{block?.content}</h3>
                        </div>
                        <button onClick={onClickRetrievedId}>
                            <span>Modifier</span>
                            {icon('back')}
                        </button>
                    </div>
                )
            default:
                return (
                    <h3
                        className={`${!isEmpty(attributes) ? 'baseocom-title-not-attributes ' : 'baseocom-title-whith-attributes '}`}
                    >
                        {block?.content}
                    </h3>
                )
        }
    }

    return (
        <>
            {block?.content && renderBlockContent()}
            {block?.childrens && <Parser content_block={block?.childrens} />}
            {!isEmpty(attributes) && <Attributes attributes={attributes} />}
        </>
    )
}

export default TitleParser
